import admins from "./admins";
import settings from "./settings";
import merchants from "./merchant";
import { isMerchant, isMerchantAdmin, isSTCAdmin } from "helper/Admin";
import { useEffect, useState } from "react";
import { getCourtPlace } from "helper/LocalStorage";

// =====================
// reactive version (same-tab + cross-tab)
// =====================
let _version = 0;
const listeners = new Set();

const notify = () => {
  _version += 1;
  listeners.forEach((fn) => fn(_version));
};

// call this after you set localStorage (optional helper)
export const bumpMenuVersion = () => notify();

// hook for React components
export const useMenuVersion = () => {
  const [v, setV] = useState(_version);

  useEffect(() => {
    const fn = (next) => setV(next);
    listeners.add(fn);

    // same tab (you already dispatch this)
    const onCustom = () => notify();
    window.addEventListener("allowed_menu_updated", onCustom);

    // other tabs
    const onStorage = (e) => {
      if (e.key === "allowed_menu") notify();
    };
    window.addEventListener("storage", onStorage);

    return () => {
      listeners.delete(fn);
      window.removeEventListener("allowed_menu_updated", onCustom);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return v;
};

// =====================
// helpers
// =====================
const getAllowedMenu = () => {
  try {
    const raw = localStorage.getItem("allowed_menu"); // set by API
    const arr = JSON.parse(raw || "[]");
    return Array.isArray(arr) && arr.length > 0 ? arr : getCourtPlace().allowedMenu;
  } catch {
    return [];
  }
};

const getPermissionKey = (node) => node?.meta?.permission || node?.permission || node?.id;

const hasPermission = (permKey, allowedSet, allowedList) => {
  if (!permKey) return true;

  if (permKey === "merchants") {
    return allowedList.some((p) => typeof p === "string" && p.startsWith("settings_"));
  }

  return allowedSet.has(permKey);
};

const filterMenuByAllowed = (node, allowedSet, allowedList) => {
  if (!node) return null;

  if (Array.isArray(node.children)) {
    const filteredChildren = node.children
      .map((c) => filterMenuByAllowed(c, allowedSet, allowedList))
      .filter(Boolean);

    const permKey = getPermissionKey(node);
    const nodeAllowed = hasPermission(permKey, allowedSet, allowedList);

    if (!nodeAllowed && filteredChildren.length === 0 && permKey) return null;

    return { ...node, children: filteredChildren };
  }

  const permKey = getPermissionKey(node);
  return hasPermission(permKey, allowedSet, allowedList) ? node : null;
};

// =====================
// export
// =====================
const menuItems = {
  get items() {
    if (!isMerchant()) {
      let allowedList = getCourtPlace().allowedMenu;
      if (allowedList) { allowedList = [...allowedList, 'users'] }
      const allowedSet = new Set(allowedList)
      if (allowedList && allowedList.length > 0) {
        let admin = [admins].map((group) => filterMenuByAllowed(group, allowedSet, allowedList)).filter(Boolean)
        return [...admin]
      }

      return [admins, settings];
    }
    // if (isSTCAdmin()) return [merchants, settings];

    let allowedList = getAllowedMenu();
    if (allowedList && allowedList.length > 0) {
      allowedList = [...allowedList, 'users']
      let allowedSet = new Set(allowedList);
      return [merchants, settings]
        .map((group) => filterMenuByAllowed(group, allowedSet, allowedList))
        .filter(Boolean);
    } else {
      return [merchants, settings]
    }
  }
};

export default menuItems;